module.exports = __webpack_public_path__ + "static/media/ACM-logo.898c738f.png";